export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40117a4c145a8a6320aa08eef0f1688f902a361292&name=revalidateCommunity!'